// Only fire the product finder js id the block is loaden on page.
const ProductFinder = document.getElementById('product-finder');
if (ProductFinder !== null) {

	const skinType = document.getElementById("skintype");
	const productCat = document.getElementById("product-cat");
	const searchButton = document.getElementById("submit-selection");
	// const wooShopArchive = document.querySelector(".archive.woocommerce-shop .wrapper.content");
	// const categoryTitleRow = document.getElementsByClassName("category-row");
	// const wooProduct = document.querySelectorAll("ul.products.columns-3 li.product.type-product");

	if (productCat) {
		productCat.addEventListener('change', (e) => {
			if (productCat.length !== 0) {
				const value = e.target.value;

				filter_product_cat_select(value);
			}
		});
	}

	// if (productCat) {
	// 	productCat.addEventListener('change', (e) => {
	// 		if (productCat.length !== 0) {
	// 			const chosenSkinType = skinType.options[skinType.selectedIndex].value;
	// 			const chosenProductCat = productCat.options[productCat.selectedIndex].value;
	// 		}
	// 	});
	// }

	if (searchButton) {
		searchButton.addEventListener('click', function (e) {
			e.preventDefault();
			const chosenProductCat = productCat.options[productCat.selectedIndex].value;
			const chosenSkinType = skinType.options[skinType.selectedIndex].value;

			if (chosenSkinType.length !== 0 || chosenProductCat.length !== 0) {
				filter_the_products(chosenSkinType, chosenProductCat)
			}
		});
	}

	function filter_the_products(skinType, productCat) {
		// Remove the category title bar counter
		let counter = document.querySelectorAll('.category-wrap .post-count');
		[].forEach.call(counter, function (item) {
			item.remove();
		});

		let skinTypeClass = "skintype-" + skinType;
		let productCatClass = "product_cat-" + productCat;

		// Remove all unwanted categories
		let productCatWrap = document.querySelectorAll('.category-wrap');
		[].forEach.call(productCatWrap, function (item) {
			if (item.classList.contains(productCatClass)) {
				item.classList.remove('hidden');
			} else {
				item.classList.add('hidden');
			}
		});

		// Hide all unwanted products
		if (skinType.length !== 0) {
			let productList = document.querySelectorAll('.products-colums-wrap ul li.product');
			[].forEach.call(productList, function (item) {
				if (item.classList.contains(skinTypeClass)) {
					item.classList.remove('hidden');
				} else {
					item.classList.add('hidden');
				}
			});
		}
	}

	function filter_product_cat_select(productCat) {
		const skinType = document.getElementById("skintype");
		const searchButton = document.getElementById("submit-selection");

		$.ajax({
			url       : js_data.ajax_url,
			data      : {
				action: "product_cat_filtered",
				productCat
			},
			type      : "POST",
			dataType  : "json",
			beforeSend: function () {
				skinType.disabled = true;
				searchButton.disabled = true;
				skinType.innerHTML = '<option hidden value="">' + js_data.lang_choose_a_skintype + '</option>';
			},
			success   : function (res) {
				if (res.success === true) {
					skinType.disabled = false;
					searchButton.disabled = false;
					skinType.innerHTML += res.data.options;
				}
			},
			error     : function (xhr, error, errornumber) {
				console.error([xhr, error, errornumber]);
			}
		});
	}
}

